import { render, staticRenderFns } from "./ForwardDialog.vue?vue&type=template&id=1a58d271"
import script from "./ForwardDialog.vue?vue&type=script&lang=js"
export * from "./ForwardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports